import { gql } from 'graphql-request'

export const RESET_USER_PASSWORD = gql`
  mutation ResetUserPassword($resetPasswordInput: ResetPasswordInput!) {
    resetUserPassword(resetPasswordInput: $resetPasswordInput) {
      message
    }
  }
`
